module.exports = __webpack_public_path__ + "assets/e0250e879c2259afb2d7ff26a2ebe741.png";